import { render, staticRenderFns } from "./questions.component.vue?vue&type=template&id=99f3a102&"
import script from "./questions.component.vue?vue&type=script&lang=ts&"
export * from "./questions.component.vue?vue&type=script&lang=ts&"
import style0 from "./questions.component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports